import './wdyr'; // <--- first import
import {initializeApp} from '@/init/app-init';
import {msalInstance} from '@/Pages/Auth/auth.config';

initializeApp(msalInstance);
